import { render, staticRenderFns } from "./DocumentiDetails.vue?vue&type=template&id=042108cf&scoped=true"
import script from "./DocumentiDetails.vue?vue&type=script&lang=js"
export * from "./DocumentiDetails.vue?vue&type=script&lang=js"
import style0 from "./DocumentiDetails.vue?vue&type=style&index=0&id=042108cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042108cf",
  null
  
)

export default component.exports